export default __webpack_public_path__ + "static/char-s-07-cht-b7527db207105da6eecf32ebf15b1842.webp";